import { Grid, Card, Text } from "@shopify/polaris";
import styles from "../../styles/components/ReviewCard/productReviewCard.css";

const TipsCard = ({ heading, text }) => {
  return (
    <Grid.Cell>
      <Card>
        <div className={styles["card-header"]}>
          <Text as="p" variant="headingSm">
            {heading}
          </Text>
        </div>
        <br />
        <div className={styles["review"]}>
          <Text as="p" variant="bodyMd">
            {text}
          </Text>
        </div>
      </Card>
    </Grid.Cell>
  );
};

export default TipsCard;
